import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { providers } from '@febos-io/common';
import { CenterCardLayout } from '@febos-io/design';

import useTranslation from '../hooks/useTranslation';
import { removeUser } from '../store';

export default function Error500Message() {
  const { t } = useTranslation();
  const { AppLogo } = providers.useAppContext();
  const dispatch = useDispatch();
  return (
    <CenterCardLayout>
      {AppLogo && (
        <>
          <AppLogo />
          <hr />
        </>
      )}
      <h1>{t('Something went wrong')}</h1>
      <ul className="list-unstyled mb-0">
        <li className="mb-2">
          <a href="/" className="btn btn-secondary">
            {t('Back to home')}
          </a>
        </li>
        <li>
          <Link
            to="/"
            className="btn btn-secondary"
            onClick={() => dispatch(removeUser())}
          >
            {t('Exit')}
          </Link>
        </li>
      </ul>
    </CenterCardLayout>
  );
}
